module.exports = __webpack_public_path__ + "img/page4.af4ee330.png";